import React, {useEffect, useState} from "react";
import Cell from "./Cell";
import {ButtonGroup, Button} from "@nextui-org/react";
import {Categories, getItemsByMachine} from "../API";
import ShoppingCart from "./ShoppingCart";
import {useVending} from "./VendingProvider";
import {NotFound} from "./NotFound";
import {toast, Toaster} from "sonner";

export const MachineList = () => {
    const [idCategory, setIdCategory] = useState(0);
    const [categories, setCategories] = useState([]);
    const [items, setItems] = useState([]);
    const [itemsFiltered, setItemsFiltered] = useState([]);
    const {idMachine} = useVending();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        Starting();
    }, []);

    async function Starting() {
        setIdCategory(0);
        setLoading(true);
        const data = await Categories();
        setCategories(data);
        const i = await getItemsByMachine(idMachine);
        setItems(i);
        setItemsFiltered(i);
        setLoading(false);
    }

    function SelectFilter(e) {
        const id = parseInt(e.target.value);
        setIdCategory(id);
        if (id === 0) {
            setItemsFiltered(items);
            return;
        }

        const filter = items.filter(item => item.idcategory === id);
        setItemsFiltered(filter);
    }

    function SetMessage(message, type){
        if(type === 'error')
            toast.error(message);
    }

    return (
        <React.Fragment>
            <Toaster richColors/>
            <div className="flex justify-between pb-5">
                <ButtonGroup variant="shadow">
                    {
                        items && items.length > 0 ? (
                            <>
                                <Button onClick={SelectFilter} color={idCategory === 0 ? "secondary" : "default"}
                                        value={0}>Todos</Button>
                                {
                                    categories.map((item, index) => (
                                        <Button onClick={SelectFilter}
                                                color={idCategory === parseInt(item.id) ? "secondary" : "default"}
                                                value={item.id} key={item.id}>{item.category}</Button>
                                    ))
                                }
                            </>
                        ) : null

                    }
                </ButtonGroup>
                {
                    items && items.length > 0 ? (<ShoppingCart/>) : null
                }

            </div>
            <div className="flex justify-center pb-5">
            </div>

            {
                itemsFiltered && itemsFiltered.length ? (
                    <div className="gap-2 grid grid-cols-2 sm:grid-cols-4">
                        {
                            itemsFiltered.map((item, index) => (
                                <Cell item={item} key={index} idmachine={idMachine} message={SetMessage}/>
                            ))
                        }
                    </div>
                ) : (
                    <NotFound loading={loading} isEmptyList={true}/>
                )

            }
        </React.Fragment>

    );
};

export default MachineList;